import "prismjs/components/prism-clike";
import "prismjs/components/prism-hcl";
import "prismjs/themes/prism.css";
import React from "react";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import DescriptionTab from "../../components/descriptionTab/DescriptionTab";
import UnsavedChangesDialog from "../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import ValidationHelper from "../../helpers/ValidationHelper";
import CamplaCoreService from "../../services/CamplaCoreService";
import StorageService from "../../services/StorageService";
import EditScriptDialog from "./dialogs/editScriptDialog/EditScriptDialog";
import ScriptInfoCard from "./scriptInfoCard/ScriptInfoCard";
import EditScriptTab from "./tabs/editScriptTab/EditScriptTab";

import "./SingleScript.css";

class SingleScript extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      script: null,
      apiError: "",
      dialogApiError: "",
      showEditDialog: false,
      closeAction: () => {
      },
      showUnsavedChangesDialog: false,
      validationResult: undefined,
      validation: ValidationHelper.getValidation(this.validationDefinition)
    };

    this.fetchData = this.fetchData.bind(this);
    this.onSubmitScript = this.onSubmitScript.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onHideEditDialog = this.onHideEditDialog.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: Object.assign(
        {},
        ValidationHelper.update(event, this.state.validation)
      )
    });
  }

  async componentDidMount() {
    const cachedScript = StorageService.getReferenceType("singleScript");
    if (cachedScript && cachedScript._id === this.props.match.params.id) {
      this.setState({ script: cachedScript });
    }

    await this.fetchData();
  }

  async fetchData() {
    try {
      const script = await CamplaCoreService.getScript(
        this.props.match.params.id
      );
      StorageService.set("singleScript", script);
      this.setState({
        script
      });
    } catch (err) {
      window.location = "/scripts";
    }
  }

  async onSubmit(changedScript) {
    this.setState({ isSaving: true });
    try {
      changedScript = Object.assign(changedScript, {
        script: btoa(changedScript.script)
      });

      const updatedScript = await CamplaCoreService.updateScript(
        this.state.script._id,
        changedScript
      );

      StorageService.set("singleScript", updatedScript);
      this.setState({
        script: updatedScript,
        showEditDialog: false,
        validationResult: ""
      });
    } catch (err) {
      try {
        const result = await CamplaCoreService.validateScript(changedScript);
        if (result.valid) {
          this.showApiError(err);
        } else {
          this.setState({
            validationResult:
              JSON.parse(result.report)?.ErrorMessage ||
              this.props.t("SingleScript.DefaultValidationMessage")
          });
        }
      } catch (err) {
        this.showApiError(err);
      }
    }
    this.setState({ isSaving: false });
  }

  async onSubmitScript(code) {
    const script = Object.assign(this.state.script, {
      script: code
    });

    await this.onSubmit(script);
  }

  onEdit() {
    this.setState({
      showEditDialog: true
    });
  }

  onHideEditDialog(isFormDirty, callback) {
    if (isFormDirty) {
      this.setState({
        showUnsavedChangesDialog: true,
        closeAction: () => {
          this.setState({
            showEditDialog: false
          });
          callback();
        }
      });
    } else {
      this.setState({
        showEditDialog: false
      });
      callback();
    }
  }

  showApiError(err) {
    this.setState({
      apiError: APIErrorHelper.getError(
        err,
        () => this.setState({ dialogApiError: "", validationResult: undefined }),
        {
          PRECONDITION_FAILED: "SingleScript.APIError.PreconditionFailed",
          NOT_FOUND: "SingleScript.APIError.NotFound",
          CONFLICT: "SingleScript.APIError.UpdateConflict"
        },
        this.props.t
      )
    });
  }

  render() {
    const { t } = this.props;
    return !this.state.script ? (
      <div />
    ) : (
      <div>
        <EditScriptDialog
          show={this.state.showEditDialog}
          script={this.state.script}
          onSubmit={this.onSubmit}
          onHide={this.onHideEditDialog}
        />
        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />
        <Container className="mt-3">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col>
              <ScriptInfoCard script={this.state.script} onEdit={this.onEdit} />
            </Col>
          </Row>
          <Row>
            <Col>
              <Tabs defaultActiveKey="1">
                <Tab
                  eventKey="1"
                  tabClassName="item-link"
                  title={t("SingleScript.DescriptionTabTitle")}
                >
                  <DescriptionTab
                    text={this.state.script.description}
                    lang={this.props.i18n.language}
                  />
                </Tab>
                <Tab eventKey="2" tabClassName="item-link" title="Script">
                  <EditScriptTab
                    title="Script"
                    script={this.state.script}
                    highlightingLanguage={this.state.script.type}
                    onSubmit={this.onSubmitScript}
                    validationResult={this.state.validationResult}
                    isSaving={this.state.isSaving}
                  />
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(SingleScript);
